import React, { useContext, useState, useMemo, useEffect } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import milan from "../assets/img/milan.png";
import hanoi from "../assets/img/hanoi.png";
import danang from "../assets/img/danang.png";
import hochiminh from "../assets/img/hochiminh.png";
import { useJobContext } from "../context/JobContext";
import { JobDetailItem, JobListDataProps } from "../pages/detailjob/Section";

const Jobs = () => {
  const navigate = useNavigate();
  const { jobs } = useJobContext();
  const [selectedRole, setSelectedRole] = useState("Select Department");
  const [selectedCity, setSelectedCity] = useState("All Locations");
  const [filteredJobs, setFilteredJobs] = useState<JobListDataProps[]>([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Extract unique roles
  const uniqueRoles = useMemo(() => {
    const roles = new Set<string>();
    Object.values(jobs || {}).forEach((job: any) => {
      // Logic: Use dept if available, otherwise parse subTitle
      const role = job.dept || job.subTitle?.split("|")[0]?.trim();
      if (role) roles.add(role);
    });
    return Array.from(roles);
  }, [jobs]);

  // Filter jobs based on selected role and search query
  useEffect(() => {
    let currentJobs = Object.entries(jobs || {});

    // Filter by Role
    if (selectedRole !== "Select Department") {
      currentJobs = currentJobs.filter(([_, job]: any) => {
        const role = job.dept || job.subTitle?.split("|")[0]?.trim();
        return role === selectedRole;
      });
    }

    // Filter by Search Query
    if (searchQuery.trim()) {
      const lowerQuery = searchQuery.toLowerCase();
      currentJobs = currentJobs.filter(([_, job]: any) =>
        job.title?.toLowerCase().includes(lowerQuery)
      );
    }

    // Filter by City
    if (selectedCity !== "All Locations") {
      currentJobs = currentJobs.filter(([_, job]: any) =>
        job.cities?.includes(selectedCity)
      );
    }

    setFilteredJobs(currentJobs.reduce((acc: any, job: any) => {
      acc.push(job);
      return acc;
    }, []));
  }, [jobs, selectedRole, searchQuery, selectedCity]);

  const imgArr = [milan, hanoi, danang, hochiminh];

  return (
    <React.Fragment>
      <section className="py-5" id="jobs">
        <Container>
          {/* FIND YOUR ROLE */}
          <h2 className="text-center fw-bold mb-4">FIND YOUR ROLE</h2>

          {/* Search + Filter */}
          <Row className="justify-content-center mb-5">
            <Col lg={8} md={10}>
              <div className="d-flex gap-3 flex-wrap flex-md-nowrap">
                {/* Search — luôn chiếm riêng 1 item */}
                <Form.Control
                  placeholder="Search Job Titles"
                  className="flex-grow-1"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />

                {/* Wrapper 2 select */}
                <div
                  className="d-flex gap-3"
                  style={{ minWidth: "fit-content" }}
                >
                  <Form.Select
                    style={{ minWidth: 150 }}
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                  >
                    <option>Select Department</option>
                    {uniqueRoles.map((role) => (
                      <option key={role} value={role}>
                        {role}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Select
                    style={{ minWidth: 150 }}
                    value={selectedCity}
                    onChange={(e) => setSelectedCity(e.target.value)}
                  >
                    <option>All Locations</option>
                    <option>Milan</option>
                    <option>Hanoi</option>
                    <option>Danang</option>
                    <option>Hochiminh</option>

                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>

          {/* CURRENT JOBS */}
          <h2 className="text-center fw-bold mb-4">CURRENT JOBS</h2>

          <Row>
            {filteredJobs.map(([key, job]: any) => (
              <Col xs={12} className="mb-3" key={key}>
                <Card
                  className="border-0 shadow-sm job-item"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/detailjob/${key}`)}
                >
                  <Row className="g-0">
                    {/* IMAGE LEFT */}
                    <Col md={3}>
                      <img
                        src={job.img || imgArr[Math.floor(Math.random() * imgArr.length)]}
                        alt={job.title}
                        className="img-fluid h-100 w-100 object-fit-cover"
                      />
                    </Col>

                    {/* TEXT CENTER */}
                    <Col
                      md={7}
                      className="p-3 d-flex flex-column justify-content-center bg-primary text-white"
                    >

                      <h2 className="mb-1 text-white">{job.title}</h2>
                      {/* spaceBetween these two lines */}
                      <br />
                      <h5 className="text-white">{job.cities.replaceAll(",", " | ")}</h5>
                    </Col>

                    {/* APPLY BUTTON RIGHT */}
                    <Col
                      md={2}
                      className="d-flex align-items-center justify-content-center bg-success"
                    >
                      <Button
                        variant="success"
                        className="fw-bold text-white border-0"
                      >
                        See Details
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        <style>{`
        .job-item img {
          object-fit: cover;
        }
        .job-item .bg-primary {
          background-color: #3818D9 !important;
        }
        .job-item .bg-success {
          background-color: #00C084 !important;
        }
        .job-item button {
          background: transparent !important;
          font-size: 14px;
          text-transform: uppercase;
        }
      `}</style>
      </section>
    </React.Fragment>
  );
};

export default Jobs;
